import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Asset, AssetInfo} from '../../shared/domain/item';
import {NotesConfig, NotesInfo} from '@rbaip/item-common-notes';

@Component({
  selector: 'lib-item-summary-item-common-notes',
  templateUrl: './item-common-notes.component.html',
  styleUrls: ['./item-common-notes.component.scss']
})
export class ItemCommonNotesComponent implements OnInit, OnChanges {
  @Input() asset: Asset;
  @Input() editable: boolean;
  @Input() editAssetFromPricing: boolean;

  notesData: {
    notesInfo: NotesInfo,
    notesConfig: NotesConfig
  };

  constructor() {
  }

  ngOnInit() {
    const assetInfo = AssetInfo.getAssetInfoFromAsset(this.asset);
    const notesConfig = new NotesConfig();
    notesConfig.sellerToDoNotesEnabled = true;
    notesConfig.sellerToDoNotesEditable = this.editAssetFromPricing || (assetInfo.isAssetOnly() && !assetInfo.isAssetPackageInPricing() && this.editable);
    notesConfig.internalNotesEnabled = true;
    notesConfig.internalNotesEditable = this.editAssetFromPricing || (assetInfo.isAssetOnly() && !assetInfo.isAssetPackageInPricing() && this.editable);
    notesConfig.catalogNotesEnabled = assetInfo.isEquip();

    // These notes will be enabled when it's time
    notesConfig.auctionAnnouncementNotesEnabled = false;
    notesConfig.operationalNotesEnabled = false;
    notesConfig.checkInNotesEnabled = false;
    notesConfig.checkOutNotesEnabled = false;

    const notesInfo = new NotesInfo();
    notesInfo.assetId = this.asset.assetId;
    notesInfo.equipId = this.asset.equipId;
    notesInfo.siteId = this.asset.siteId;
    this.notesData = {
      notesInfo,
      notesConfig
    };
  }

  public ngOnChanges(changes: SimpleChanges) {
    if ( changes.editable && this.notesData && this.notesData.notesConfig) {
      this.notesData.notesConfig.internalNotesEditable = this.notesData.notesConfig.internalNotesEditable
        && this.editable;
      this.notesData.notesConfig.sellerToDoNotesEditable = this.notesData.notesConfig.internalNotesEditable
        && this.editable;
    }
  }
}
